import { useState } from 'react';

import { getListOfStores } from 'features/mozart-notifications/infra';

import type { ChangeEvent } from 'react';
import type { StoreId } from 'shared/domain';

const NUMBER_OF_OPTIONS_TO_SHOW = 3;
const STORE_ID_DEFAULT: StoreId = 0;

export function useStoreSelector(props: Props) {
  const { labelOfStoreDefault } = props;

  const [id, setId] = useState(STORE_ID_DEFAULT);

  const _stores = getListOfStores();
  const list = [
    { id: STORE_ID_DEFAULT, name: labelOfStoreDefault },
    ..._stores,
    // { id: 2222, name: 'Mi otra tienda gracias' }, // test multi-stores
  ];

  const isMultiple = list.length >= NUMBER_OF_OPTIONS_TO_SHOW;

  const handleSelectedStoreId = (event: ChangeEvent<{ value: unknown }>) => {
    const storeId = event.target.value as StoreId;
    setId(storeId);
  };

  return {
    id,
    list,
    isMultiple,
    handleSelectedStoreId,
  };
}

interface Props {
  labelOfStoreDefault: string;
}
